import { render, staticRenderFns } from "./StarSolid.vue?vue&type=template&id=72357554&"
import script from "./StarSolid.vue?vue&type=script&lang=ts&"
export * from "./StarSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports